import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeId } from '../challenge/useChallengeId'

export const TEAMS_QUERY_KEY = (challengeID: string) => ['teams', challengeID] as const

export function useTeams(challengeId?: string) {
  const activeChallengeId = useChallengeId()
  const resolvedChallengeId = challengeId || activeChallengeId

  return useQuery({
    queryKey: TEAMS_QUERY_KEY(resolvedChallengeId),
    queryFn: () => dataSource.getTeams(resolvedChallengeId),
    enabled: !!resolvedChallengeId,
  })
}
